import { formatNumber, formatUsd } from "../../config/trading";
import { TableHeader } from "./TableHeader";

const ASSET_COLUMNS = ["Asset", "Balance", "USDT Value"];

export function AssetList({ assets }) {
  return (
    <div className="panel assets-panel" data-testid="portfolio-assets-panel">
      <div className="panel-head"><span className="label">ASSETS</span></div>
      <div className="table-like">
        <TableHeader variant="asset" testId="portfolio-assets-table-header" columns={ASSET_COLUMNS} />
        {assets.map((asset) => (
          <div className="asset-row" key={asset.asset} data-testid={`asset-${asset.asset.toLowerCase()}-row`}>
            <span>{asset.asset}</span>
            <span className="mono">{formatNumber(asset.balance, 8)}</span>
            <strong className="mono">{formatUsd(asset.usdt_value)}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}